import {
    ContextualMenu,
    DirectionalHint,
    IContextualMenuItem,
} from '@fluentui/react/lib/ContextualMenu';
import { LinkIdContainer } from 'owa-attachment-link-common';
import EditorViewState from 'owa-editor/lib/store/schema/EditorViewState';
import { RecipientContainer } from 'owa-link-data';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { LinkPlaceholderContextMenuItem } from './LinkPlaceholderContextMenuItem';

export interface LinkPlaceholderContextMenuProps {
    linkId: string;
    placeholder: HTMLSpanElement;
    editorViewState: EditorViewState;
    getRecipientWells: () => RecipientContainer[];
    linkIdContainer: LinkIdContainer;
    fromAddress: string;
    targetWindow: Window;
    sxsId: string;
}

export const LinkPlaceholderContextMenu = (contextMenuProps: LinkPlaceholderContextMenuProps) => {
    const contextMenuItems: IContextualMenuItem[] = [];
    contextMenuItems.push({
        key: 'contextualInsertLink',
        onRender: (
            item: any,
            dismissMenu: (ev?: any, dismissAll?: boolean) => void
        ): React.ReactNode => {
            return (
                <LinkPlaceholderContextMenuItem
                    linkId={contextMenuProps.linkId}
                    editorViewState={contextMenuProps.editorViewState}
                    getRecipientWells={contextMenuProps.getRecipientWells}
                    linkIdContainer={contextMenuProps.linkIdContainer}
                    fromAddress={contextMenuProps.fromAddress}
                    targetWindow={contextMenuProps.targetWindow}
                    sxsId={contextMenuProps.sxsId}
                />
            );
        },
    });
    const onDismiss = (ev: any) => {
        closeLinkPlaceholderContextMenu();
    };
    return (
        <ContextualMenu
            target={contextMenuProps.placeholder}
            shouldFocusOnMount={true}
            onDismiss={onDismiss}
            items={contextMenuItems}
            directionalHint={DirectionalHint.bottomLeftEdge}
            gapSpace={2}
        />
    );
};

let linkPlaceholderContextMenuContainer: HTMLSpanElement | null = null;
export function showLinkPlaceholderContextMenu(
    linkPlaceholder: HTMLSpanElement,
    linkId: string,
    editorViewState: EditorViewState,
    getRecipientWells: () => RecipientContainer[],
    linkIdContainer: LinkIdContainer,
    fromAddress: string,
    targetWindow: Window,
    sxsId: string
) {
    const document = (targetWindow || window).document;
    linkPlaceholderContextMenuContainer = document.createElement('span');
    linkPlaceholderContextMenuContainer.id = 'LinkPlaceholdContextMenu';
    linkPlaceholder.appendChild(linkPlaceholderContextMenuContainer);

    ReactDOM.render(
        <React.StrictMode>
            <LinkPlaceholderContextMenu
                placeholder={linkPlaceholder}
                linkId={linkId}
                editorViewState={editorViewState}
                getRecipientWells={getRecipientWells}
                linkIdContainer={linkIdContainer}
                fromAddress={fromAddress}
                targetWindow={targetWindow}
                sxsId={sxsId}
            />
        </React.StrictMode>,
        linkPlaceholderContextMenuContainer
    );
}

export function closeLinkPlaceholderContextMenu() {
    if (linkPlaceholderContextMenuContainer) {
        ReactDOM.unmountComponentAtNode(linkPlaceholderContextMenuContainer);
        if (linkPlaceholderContextMenuContainer.parentNode) {
            linkPlaceholderContextMenuContainer.parentNode.removeChild(
                linkPlaceholderContextMenuContainer
            );
        }
        linkPlaceholderContextMenuContainer = null;
    }
}
